<template>
  <div class="main container">
    <div class="logo col-md-12 text-center">
      <img src="./../../assets/logo-10.png">
    </div>
    <div class="col-md-12 text-center">
      <h4 class="highlight-color">{{ $t('message.resetpassword') }}</h4>
      <p class="highlight-color">{{ $t('message.intro1') }}</p>
    </div>
    <template v-if="is_valid_token && !reset_password_success">
      <div class="col-md-6 form">
        <div class="form-group">
          <label>{{ $t('message.newpassword') }}</label>
          <input
            :disabled="$store.state.app.loading == true"
            v-model="form.password"
            type="password"
            class="form-control">
        </div>
        <div class="form-group">
          <label>{{ $t('message.confirmpassword') }}</label>
          <input
            :class="[{'is-invalid': !isMatchedPassword && form.password.length > 0 && form.confirm_password.length > 0}]"
            :disabled="$store.state.app.loading == true"
            v-model="form.confirm_password"
            type="password"
            class="form-control">
          <div class="invalid-feedback">
            {{ $t('message.passworddoesnotmatch') }}
          </div>
        </div>
        <button
          :disabled="disabledResetPassword"
          type="submit"
          class="btn btn-web btn-block"
          @click="resetPassword()">
          <span v-if="$store.state.app.loading"><i class="fas fa-spinner spin"/></span>
          <span v-else>{{ $t('button.confirm') }}</span>
        </button>
      </div>
    </template>
    <template v-if="is_valid_token && reset_password_success">
      <div class="col-md-6 form">
        <p class="m-0 text-center text-success">
          {{ $t('message.resetpasswordsuccess') }} <i class="far fa-check-circle"/>
        </p>
      </div>
    </template>
    <template v-if="!is_valid_token">
      <div class="col-md-6 form">
        <p class="m-0 text-center text-danger">
          {{ $t('message.tokenwasexpired') }} <i class="fas fa-exclamation"/>
        </p>
        <hr >
        <p
          class="m-0"
          style="font-size: 13px;">
          {{ $t('message.notetokenexpired') }}
        </p>
        <!-- <p>
          คุณสามารถรับลิงค์เพื่อเปลี่ยนรหัสใหม่ได้อีกครั้ง โดยคลิกที่ปุ่มด้านล่างนี้
        </p>
        <p>
          <button type="button"
                  class="btn btn-web btn-block">
            รับลิงค์เปลี่ยนรหัสผ่านใหม่
          </button>
        </p>
        <p class="m-0">
          หมายเหตุ: ลิงค์จะหมดอายุภายใน 30 นาที เพื่อความปลอดภัยสำหรับบัญชีผู้ใช้ของคุณ
        </p> -->
      </div>
    </template>
    <div
      v-if="!is_valid_token || reset_password_success"
      class="col-md-12 text-center">
      <p class="text-white mb-1">
        <router-link
          :to="{
            name: 'SignIn'
          }"
          class="text-white">
          {{ $t('message.login') }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const jwt = require('jsonwebtoken')

export default {
  name: 'SignIn',
  data () {
    return {
      ready: false,
      is_valid_token: false,
      reset_password_success: false,

      form: {
        password: '',
        confirm_password: '',
        token: '',
      },
    }
  },
  computed: {
    ...mapGetters({

    }),
    isMatchedPassword () {
      let password = this.form.password.trim()
      let confirm_password = this.form.confirm_password.trim()

      if (password.length == 0 && confirm_password.length == 0) {
        return false
      }

      return password == confirm_password
    },
    isValidPassword () {
      let password = this.form.password.trim()
      let confirm_password = this.form.confirm_password.trim()

      return !!(password.length >= 6 && confirm_password.length >= 6)
    },
    disabledResetPassword () {
      return !this.isMatchedPassword || !this.isValidPassword || this.$store.state.app.loading
    },
  },
  methods: {
    ...mapActions([

    ]),
    async resetPassword () {
      let dataSet = {
        token: this.form.token,
        password: this.form.password,
      }

      let res = await this.$store.dispatch('resetPassword', dataSet)

      if (!res.success) {
        this.is_valid_token = false
      } else {
        this.reset_password_success = true
      }
    },
  },
  created: async function () {
    let token = this.$route.query.token

    if (token == undefined) {
      return this.$router.push({ name: 'signin' })
    }

    let res = await this.$store.dispatch('forgotPasswordCheck', {
      token: token,
    })

    if (res.success) {
      this.is_valid_token = true
      this.form.token = token
    }

    this.ready = true
  },
  mounted: function () {
    // set section
    this.$store.dispatch('setSection', 'login')
    // set title
    this.setTabTitle(this.$t('message.resetpassword'))
  },
}
</script>
<style scoped>
.main {

}
.logo {
  margin: 25px 0 25px 0;
}
.form {
  padding: 25px 25px 20px 25px;
  max-width: 400px;
  margin: 25px auto;
  background: #FFF;
  border-radius: 2px;
}
.text {
  color: #282D35;
}
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/account/ResetPassword.vue